import { Utils } from "../../../../shared/utils";

export class PartnersConst {
  public static headerTable = [
    { field: 'nameOrBusinessName', title: 'Nombre o razón social', cell: (row) => `${row.nameOrBusinessName}`, class: (row) => `` },
    { field: 'vatNumber', title: 'CIF/NIF', cell: (row) => `${row.vatNumber}`, class: (row) => `` },
    { field: 'participation', title: '% Participación', cell: (row) => `${row.participation}`, class: (row) => `` },
    { field: 'participationAmount', title: 'Importe participación', cell: (row) => `${row.participationAmount}`, class: (row) => `` },
    { field: 'accountingModels118', title: 'Cuenta Contable 118', cell: (row) => `${row.accountingModels118}`, class: (row) => `` },
    { field: 'accountingModels551', title: 'Cuenta Contable 551', cell: (row) => `${row.accountingModels551}`, class: (row) => `` },
  ];
}

export class TransactionConst {
  public static headerTable = [
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },
    { field: 'description', title: 'Descripción', cell: (row) => `${row.description ? row.description : ''}`, class: (row) => '' },
    { field: 'amount', title: 'Cantidad', cell: (row) => `${row.amount}  `, class: (row) => `` },
    { field: 'typePay', title: 'Método de pago', cell: (row) => row.typePay ? `${row.typePay}` : '', class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Efectivo / Banco', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
    { field: 'transactionType', title: 'tipo de transacción', cell: (row) => `${row.transactionType ? 'Aportación' : 'Devolución'}  `, class: (row) => '' },
  ];
}